module.exports = __webpack_public_path__ + "static/1313435329-wide.44c0ae01.jpg";